import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as hotelActions from './../../../../actions/hotelAction';
import * as rateActions from './../../../../actions/rateAction';
import Hotels from './Hotels';

const mapStateToProps = state => {
    return {
        hotelState: state.hotelReducer,
        rateState: state.rateReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListHotels: (filters) => dispatch(hotelActions.getListHotels(filters)),
        syncRates: (hotelId) => dispatch(rateActions.syncRates(hotelId)),
        syncRatesAllHotel: () => dispatch(rateActions.syncRatesAllHotels()),
        clearCache: (type) => dispatch(hotelActions.clearCache(type)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Hotels));
